// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import KSB from './pages/KSB';
import Contact from './pages/Contact';
import BlogPage from './pages/BlogPage';
import AdminBlog from './pages/AdminBlog';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ksb/*" element={<KSB />} />
            <Route path="/kontakt/*" element={<Contact />} />
            <Route path="/blog/*" element={<BlogPage />} />
            <Route path="/adminblog" element={<AdminBlog />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;